import * as React from "react"
import { cn } from "@/lib/utils"

interface AuroraTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
  as?: React.ElementType
}

export function AuroraText({
  children,
  as: Component = "span",
  className,
  ...props
}: AuroraTextProps) {
  return (
    <Component
      className={cn(
        "animate-aurora-text bg-[linear-gradient(to_right,#ff1b6b,#ff4181,#ff70a6,#ff9ccd,#45caff,#8b5cf6,#db2777,#f472b6,#ff6b95,#00d4ff,#a855f7,#ec4899,#ff1b6b)] bg-clip-text text-transparent bg-[length:400%_400%]",
        className
      )}
      {...props}
    >
      {children}
    </Component>
  )
} 